import { useMemo } from "react";

import { usePMIDs } from "shell/platform/hooks/usePMIDs";

import { ConfigureModal } from "../shared/ConfigureModal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const PMCodeConfigurationModal = ({ isOpen, onClose }: Props) => {
  const { activePMID, availablePMIDs, onPMIDChange } = usePMIDs();

  const formattedOptions = useMemo(
    () =>
      availablePMIDs.map(current => ({
        id: current.pmid,
        name: current.pmCode,
      })),
    [availablePMIDs],
  );

  return (
    <ConfigureModal
      isOpen={isOpen}
      onClose={onClose}
      title="Configure PM code"
      value={activePMID}
      onChange={value => onPMIDChange(value)}
      options={formattedOptions}
      type="PM code"
    />
  );
};
